// dependencies
import PropTypes from "prop-types";
import React, { useState } from "react";

import Button from "../../../components/Button";
// components
import TextInput from "../../../components/Inputs/TextInput";

// styles
import css from "./LogDetails.module.scss";

const Search = (props) => {
	const [search, setSearch] = useState("");
	const handleSearch = () => {
		props.updateSearch(search);
	};
	const handleReset = () => {
		setSearch("");
		props.updateSearch(null);
	};

	return (
		<div className={css.searchTool}>
			<TextInput
				onEnter={handleSearch}
				className={css.searchField}
				onChange={(value) => setSearch(value)}
				value={search}
				placeholder="Search employee..."
			/>
			<span title="Search">
				<Button className={css.searchButton} onClick={handleSearch}>
					Submit
				</Button>
			</span>
			<span title="Clear Search">
				<Button className={`${css.searchButton} ${css.resetButton}`} onClick={handleReset}>
					Clear
				</Button>
			</span>
		</div>
	);
};

Search.propTypes = {
	updateSearch: PropTypes.func.isRequired,
};

export default Search;
